import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const usePageLoader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showContent, setShowContent] = useState(true);
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    // Only show loader if the pathname actually changed
    if (prevLocationRef.current !== location.pathname) {
      setIsLoading(true);
      setShowContent(false);
      
      // Show loader for minimum 400ms for better UX and to ensure it's visible
      const timer = setTimeout(() => {
        setIsLoading(false);
        // Small delay before showing content to ensure smooth transition
        setTimeout(() => {
          setShowContent(true);
        }, 100);
      }, 400);

      prevLocationRef.current = location.pathname;

      return () => {
        clearTimeout(timer);
      };
    }
  }, [location.pathname]);

  return { isLoading, showContent };
};